export default __webpack_public_path__ + "static/media/10.b51cc1cd.png";